import React from 'react';
import { ToggleRouter } from './toggleRouter';

export const ToggleContext = React.createContext<ToggleRouter>(new ToggleRouter());
